
            const data = {"name":"send","data":{"width":"18","height":"18","viewBox":"0 0 18 18","data":"<path pid=\"0\" d=\"M16.5 1.5 8.25 9.75M16.5 1.5l-5.25 15-3-6.75-6.75-3 15-5.25Z\" _stroke=\"#000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#000"}],"stopColors":[]}}
        
                    module.exports = data
                    